import {
  createUnifiedTheme,
  pageTheme as defaultPageThemes,
  palettes,
} from '@backstage/theme';

// 디자인(Google Material 톤): 웨이브 없는 단색 헤더·nav, 경계 1px
type Tokens = {
  base: (typeof palettes)[keyof typeof palettes];
  primary: string;
  navSelected: string;
  background: { default: string; paper: string };
  surface: string; // nav·헤더 배경
  border: string;
  text: string;
  textSecondary: string;
  navText: string;
  hover: string;
};

const createPortalTheme = (t: Tokens) => {
  const header = {
    colors: [t.surface],
    shape: 'none',
    backgroundImage: 'none',
    fontColor: t.text,
  };
  return createUnifiedTheme({
    palette: {
      ...t.base,
      primary: { main: t.primary },
      background: t.background,
      text: { primary: t.text, secondary: t.textSecondary },
      navigation: {
        ...t.base.navigation,
        background: t.surface,
        indicator: t.primary,
        color: t.navText,
        selectedColor: t.navSelected,
        navItem: { hoverBackground: t.hover },
        submenu: { background: t.hover },
      },
    },
    fontFamily: "Roboto, 'Noto Sans KR', Arial, sans-serif",
    pageTheme: Object.fromEntries(
      Object.keys(defaultPageThemes).map(id => [id, header]),
    ),
    components: {
      BackstageSidebar: {
        styleOverrides: {
          drawer: { borderRight: `1px solid ${t.border}` },
        },
      },
      BackstageHeader: {
        styleOverrides: {
          header: {
            backgroundColor: t.surface,
            boxShadow: 'none',
            borderBottom: `1px solid ${t.border}`,
          },
          // 기본값은 fontColor + opacity 라 대비가 흐려진다 → 보조색 고정(4.5:1 이상)
          subtitle: { color: t.textSecondary, opacity: 1 },
          type: { color: t.textSecondary, opacity: 1 },
          breadcrumb: { color: t.textSecondary },
        },
      },
      BackstageHeaderLabel: {
        styleOverrides: {
          value: { color: t.textSecondary },
        },
      },
    },
  });
};

export const portalLightTheme = createPortalTheme({
  base: palettes.light,
  primary: '#1A73E8',
  // #1A73E8 은 hover 배경(#F1F3F4) 위에서 3.97:1 → Google 선택 톤
  navSelected: '#1967D2',
  background: { default: '#FFFFFF', paper: '#FFFFFF' },
  surface: '#FFFFFF',
  border: '#DADCE0',
  text: '#202124',
  textSecondary: '#5F6368',
  navText: '#3C4043',
  hover: '#F1F3F4',
});

export const portalDarkTheme = createPortalTheme({
  base: palettes.dark,
  primary: '#8AB4F8',
  navSelected: '#8AB4F8',
  background: { default: '#202124', paper: '#303134' },
  surface: '#202124',
  border: '#3C4043',
  text: '#E8EAED',
  textSecondary: '#9AA0A6',
  navText: '#E8EAED',
  hover: '#303134',
});
